import React from 'react';

import { IStatusIndicator, STATUS_INDICATOR_VARIANT } from '@belong/types';

import { VisuallyHidden } from '../../styles/Typography/VisuallyHidden';
import {
  IconWrapper,
  StatusIcon,
  StatusIndicatorLight,
  StatusIndicatorText,
  StatusIndicatorWrapper
} from './StatusIndicator.styles';

/**
 * Use the controls available in the sidebar to configure your own <code>StatusIndicator</code>
 */
export const StatusIndicator: React.FC<IStatusIndicator> = ({
  status,
  children,
  type = STATUS_INDICATOR_VARIANT.DEFAULT,
  withIcon = false,
  iconName,
  a11yPrefixStatusIndicator = `Status: `,
  ...props
}) => {
  const noStatusLight = type !== STATUS_INDICATOR_VARIANT.NO_STATUS_LIGHT;
  return (
    <>
      <VisuallyHidden>{a11yPrefixStatusIndicator}</VisuallyHidden>

      <StatusIndicatorWrapper type={type} status={status}>
        <IconWrapper withIcon={withIcon}>
          {withIcon && noStatusLight && <StatusIcon status={status} iconName={iconName} />}

          <StatusIndicatorText variant="small" isBold status={status} as="span" {...props}>
            {!withIcon && noStatusLight && <StatusIndicatorLight status={status} type={type} />}
            {children}
          </StatusIndicatorText>
        </IconWrapper>
      </StatusIndicatorWrapper>
    </>
  );
};

StatusIndicator.displayName = 'StatusIndicator';
